import React, { Component } from "react";

import "./Map.css";
class Map extends Component {
  render() {
    return (
      <React.Fragment>
        <svg
          version="1.1"
          viewBox="0 0 2000 1250"
          xmlns="http://www.w3.org/2000/svg"
          className="mainMap"
          width="900"
          height={this.props.svgMapHeihgt}
        >
          <g fill="#DFDFDF" stroke="#FFFFFF" strokeWidth="0.5">
            {this.props.counties.map((county) => {
              return (
                <React.Fragment key={"map-" + county.name + "-" + county.id}>
                  <path
                    fill={
                      this.props.hoverCounty === county.id
                        ? "#b6dcd5"
                        : this.props.active.id === county.id
                        ? "#02D4B7"
                        : ""
                    }
                    id={county.id}
                    d={county.path.d}
                    onClick={() => this.props.SetCounty(county)}
                    onMouseEnter={this.props.HoverCountyEnter}
                    onMouseLeave={this.props.HoverCountyLeave}
                  />
                </React.Fragment>
              );
            })}
          </g>
        </svg>
      </React.Fragment>
    );
  }
}
export default Map;
